<div class="loginboxContainer">
    <a  href="#" class="mb-4 d-block text-center">
        <img src="assets/images/wakandi_logo_green.png" width="150" class="m-b-30" alt=""> </a>
    <div class="card text-center">
        <div class="header brd-0 mt-0 mb-2">
            <h2>{{ "InvalidLink" | localize }}</h2>
        </div>
        <div class="card-body">
            <p>{{"InvalidOrExpiredLink" | localize}}</p>
        </div>
    </div>
</div>